var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 15.3c.2.2.3.4.3.7s-.1.5-.3.7c-.4.4-1 .4-1.4 0L12 13.4l-3.3 3.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3.3-3.3-3.3-3.3C7.1 8.5 7 8.3 7 8s.1-.5.3-.7c.4-.4 1-.4 1.4 0l3.3 3.3 3.3-3.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L13.4 12l3.3 3.3z"
  })));
}

export default SvgIconClose;